import React from 'react';
import { useIntl } from 'react-intl';

import { FormControl, Text, View } from '@fhs-legacy/universal-components';
import Footer from 'components/footer';
import { StoreChangeDisclaimer } from 'pages/store-locator/store-change-disclaimer';

import { SearchBar } from '../search-bar';
import { StoreLocatorViews } from '../types';

import { useAutoPromptLocationPermission } from './hooks/use-auto-prompt-location-permission';
import { ListView } from './list-view';
import { MapView } from './map-view';
import { useStoreLocatorContext } from './store-locator-provider';
import { MaxWidthFullHeight, SearchContainer, TopSelectionContainer } from './store-locator.styled';

const STORE_LOCATOR_ADDRESS_HEADING_ID = 'store-locator-address-heading';

export const StoreLocatorView: React.FC<{}> = () => {
  const { formatMessage } = useIntl();

  const { ErrorDialog, Dialog, currentView } = useStoreLocatorContext();

  // Automatically open native dialog asking for location permission if not already answered
  useAutoPromptLocationPermission();

  return (
    <>
      <View testID="store-locator-wrapper" flexGrow={1}>
        <TopSelectionContainer>
          <SearchContainer>
            <FormControl paddingX="$4" mb="$0" mt="$2">
              <Text
                nativeID={STORE_LOCATOR_ADDRESS_HEADING_ID}
                accessibilityRole="header"
                mb="$2"
                fontSize="sm"
                fontWeight="medium"
              >
                {formatMessage({ id: 'enterYourDeliveryAddress' })}
              </Text>
              <SearchBar addressHeadingNativeId={STORE_LOCATOR_ADDRESS_HEADING_ID} />
            </FormControl>
          </SearchContainer>
        </TopSelectionContainer>

        <View>
          <StoreChangeDisclaimer marginX="$4" marginTop="$2" marginBottom="$4" />
        </View>
        {currentView === StoreLocatorViews.LIST_VIEW ? (
          <ListView />
        ) : (
          <MaxWidthFullHeight>
            <MapView />
          </MaxWidthFullHeight>
        )}
      </View>
      <Footer />
      <ErrorDialog />
      <Dialog />
    </>
  );
};
